export default __webpack_public_path__ + "static/media/basket.068c03af.svg";